import File from './file';
import Region from './region';

export default {
  File,
  Region,
};
